export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-500 w-8 h-8 flex items-center justify-center"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">联系我们</h2>
          <p className="text-foreground-500 text-sm mb-8 leading-relaxed">
            如果你有漫画推荐、合作投稿、版权问题或任何建议，欢迎通过以下方式联系我们。
            土豪漫画网始终倾听每一位读者的声音，共同打造更好的漫画阅读社区。
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="mailto:contact@tuhaomanhua.com"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full whitespace-nowrap transition-all cursor-pointer"
            >
              <i className="ri-mail-line text-lg w-5 h-5 flex items-center justify-center"></i>
              发送邮件
            </a>
            <a
              href="#hero"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium text-sm rounded-full whitespace-nowrap transition-all cursor-pointer border border-background-200/70"
            >
              <i className="ri-chat-smile-2-line text-lg w-5 h-5 flex items-center justify-center"></i>
              意见反馈
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}